import testService from 'ApiService/Teacher/TestService';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const TrainingMaterialUpload = ({
  formData,
  handleInputChange,
  setDisable,
}) => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const { state } = useContext(AuthContext);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [errors, setErrors] = useState([]);

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await testService.getAllCourses();
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleCourseChange = (e) => {
    const courseId = e.target.value;
    const course = courses.find((course) => course.courseId === courseId);
    setSelectedCourse(course);
    handleInputChange(e);
    handleInputChange({ target: { name: 'batchId', value: '' } });
  };

  useEffect(() => {
    const newErrors = [];
    if (
      !formData.title ||
      !formData.description ||
      !formData.courseId ||
      !formData.batchId ||
      !formData.Url
    ) {
      newErrors.push('All fields are mandatory.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [setDisable, formData]);

  return (
    <div className="rounded-[20px] p-4">
      <h4 className="mb-6 text-xl font-bold text-navy-700 dark:text-white">
        Create Lecture Links
      </h4>

      <div className="space-y-4">
        <div>
          <label className="text-sm font-bold text-navy-700 dark:text-white">
            Title*
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
            placeholder="Enter video title"
          />
        </div>

        <div>
          <label className="text-sm font-bold text-navy-700 dark:text-white">
            Description*
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
            placeholder="Enter video description"
            rows="3"
          />
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label className="text-sm font-bold text-navy-700 dark:text-white">
              Course*
            </label>
            <select
              name="courseId"
              value={formData.courseId}
              onChange={handleCourseChange}
              className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
            >
              <option value="">Select Course</option>
              {loadingCourses ? (
                <option>Loading courses...</option>
              ) : courses.length === 0 ? (
                <option className="cursor-pointer font-bold text-brand-500">
                  No courses available
                </option>
              ) : (
                courses.map((course, i) => (
                  <option key={course.courseId} value={course.courseId}>
                    {i + 1}. {course.courseName}
                  </option>
                ))
              )}
            </select>
          </div>

          <div>
            <label className="text-sm font-bold text-navy-700 dark:text-white">
              Batch*
            </label>
            <select
              name="batchId"
              value={formData.batchId}
              onChange={handleInputChange}
              className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
            >
              <option value="">Select Batch</option>
              {selectedCourse?.batches.map((batch) => (
                <option key={batch._id} value={batch._id}>
                  Batch {batch.batchNumber} -{' '}
                  {new Date(batch.startDate).toLocaleDateString()} to{' '}
                  {new Date(batch.endDate).toLocaleDateString()}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div>
          <label className="text-sm font-bold text-navy-700 dark:text-white">
            File URL*
          </label>
          <input
            type="url"
            name="Url"
            value={formData.Url}
            onChange={handleInputChange}
            className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
            placeholder="Enter URL for lecture"
          />
        </div>
      </div>
      {errors.length > 0 && (
        <div className="mt-2 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrainingMaterialUpload;
